import { Col, Row, Spin,Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import ActionBar from "../../../../../components/action-bar";
import ActionButton from "../../../../../components/action-button";
import TextAnexo from "../../../../../components/text-anexo";
import TextItem from "../../../../../components/text-item";
import useFormatter from "../../../../../hooks/useFormatter";
import useLoading from "../../../../../hooks/useLoading";
import { contratoSelector, fetchContrato, isEditableSelector } from "../../../../../store/empresa";
import { openPopup, openPopupAssinaturas } from "../../../../../util/window";
import useModulo from "../../../../../hooks/useModulo";
import { EmpresaContrato, findByIdAndMap } from "../../../../../constants";
import { contratosAlertaNivelSelector } from "../../../../../store/empresa";
import { Alerta } from "../../../../../constants";
import { useLocation } from "react-router";
import { useState } from "react";
import TarefasDrawer from "../../../licencas/_tarefasDrawer";
import useDispatchWithResult from "../../../../../hooks/useDispatchWithResult";
import { verificarAssinatura } from "../../../../../store/assinatura";

const { Orgao } = EmpresaContrato;

export default function EmpresaContratoDetailPage1() {
  const { t } = useTranslation();
  const isEditable = useSelector(isEditableSelector);
  const contrato = useSelector(contratoSelector);
  const { formatDateTime, formatDate, formatBoolean } = useFormatter();
  const loading = useLoading(fetchContrato.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const nivel = useSelector(contratosAlertaNivelSelector);
  const empresaId = match.params.empresaId;
  const id = match.params.id;
   const dispatch = useDispatchWithResult();
  const { moduloBasePath } = useModulo();
    const location = useLocation();
    const pathname = location.pathname;
    const origem = pathname.substring(pathname.indexOf("/empresas"));
    const modulo = pathname.split("/")[1];
    const [tarefasDrawerVisible, setTarefasDrawerVisible] = useState(false);

  const isNA = nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleOpenPopupAssinaturas = () => {
      const anexo = contrato?.anexo
      const uid = anexo?.uid;
  
  dispatch(verificarAssinatura())
    .then((response) => {
      if (!uid || !uid.includes("/")) {
        message.error("É necessário salvar o anexo antes da assinatura.");
        return;
      }
      openPopupAssinaturas(uid);
    })
    .catch((response) => {
      Modal.error({
        title: "Erro ao enviar para assinatura",
        content: response.mensagem,
        centered: true,
      });
    });
  
  
    };
  

  const handleEdit = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/contratos/${id}/edit`);
  };

  const handleBack = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/contratos`);
  };

  const handleLogs = () => {
    openPopup(`/logs?categoria=/empresas/${empresaId}/contratos/${id}/`, `logs_/empresas/${empresaId}/contratos/${id}/`);
  };

  return (
    <Spin spinning={loading}>
      <TarefasDrawer visible={tarefasDrawerVisible} origem={origem} modulo={modulo} empresaId={empresaId}  onClose={() => setTarefasDrawerVisible(false)} />
      <ActionBar>
        <ActionButton.Tarefa disabled={isNA} onClick={() => setTarefasDrawerVisible(true)} />
        {isEditable && <ActionButton.Edit onClick={handleEdit} disabled={isNA} />}
        <ActionButton.Back onClick={handleBack} />
        <ActionButton.Logs noTitle onClick={handleLogs} />
      </ActionBar>
      <Row gutter={[16, 8]}>
        <Col flex="400px">
          <TextItem label={t("Nome do Ato")}>{contrato?.nomeAto}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t("Data do Ato")}>{formatDate(contrato?.dataAto)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t("Data de Registro")}>{formatDate(contrato?.dataRegistro)}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="400px">
          <Row gutter={[16, 8]}>
            <Col span={10}>
              <TextItem label={t("Órgão")}>{findByIdAndMap(Orgao, contrato?.orgao, (orgao) => t(orgao.label))}</TextItem>
            </Col>
            <Col span={10}>
              <TextItem label={t("Possui Sócio no Exterior")}>{formatBoolean(contrato?.possuiSocioExterior)}</TextItem>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={[16, 8]} alignItems="center">
        <Col flex="165px">
          <TextAnexo label={t("Anexo")} value={contrato?.anexo} />
        </Col>
        { contrato?.anexo && <Col flex="165px">
          <ActionButton.Assinatura onClick={handleOpenPopupAssinaturas}  style={{ marginTop: '11px'}}/>
        </Col>}
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="600px">
          <TextItem label={t("Livro Digital")}>{contrato?.livroDigital?.natureza}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextItem label={t("Observação")}>{contrato?.obs}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label="Criado em">{formatDateTime(contrato?.createdAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Alterado em">{formatDateTime(contrato?.updatedAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Id">{contrato?.id}</TextItem>
        </Col>
      </Row>
    </Spin>
  );
}
